import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';

const styles = {
    successColor: {
        color: "#696969",
    },
    errorColor: {
        color: "#F44336"
    },
};

class Tual extends Component {

    constructor(props){
        super(props);

        this.state = {
            tualAlbumEbatValue:null,
            tualAlbumText:null,
            tualAlbumNumber:1,
        }
    }

    tualAlbumEbatChange(event, index, value) {
        this.setState({
            tualAlbumEbatValue: value,
            tualAlbumText:event.target.innerText,
        });

    }



    tualSubmit(e){
        this.props.onChange1(this.state.tualAlbumEbatValue, this.state.tualAlbumText, this.props.number,this.state.tualAlbumNumber);
    }

    render(){
        return(
            <div className="full-width">
                <div className="form-group">
                    <SelectField
                        floatingLabelText="Tual Ebatı"
                        floatingLabelStyle={styles.successColor}
                        value={this.state.tualAlbumEbatValue}
                        onChange={this.tualAlbumEbatChange.bind(this)}
                    >
                        <MenuItem value={1} primaryText="25x50"/>
                        <MenuItem value={2} primaryText="30x30"/>
                        <MenuItem value={3} primaryText="30x40"/>
                        <MenuItem value={4} primaryText="30x50"/>
                        <MenuItem value={5} primaryText="40x40"/>
                        <MenuItem value={6} primaryText="50x50"/>
                        <MenuItem value={7} primaryText="50x60"/>
                        <MenuItem value={8} primaryText="50x70"/>
                        <MenuItem value={9} primaryText="50x100"/>
                        <MenuItem value={10} primaryText="70x100"/>
                        <MenuItem value={11} primaryText="75x100"/>
                    </SelectField>
                </div>

                <div className="form-group">
                    <TextField
                        type="number"
                        hintText="Tual Sayısı"
                        floatingLabelStyle={styles.successColor}
                        floatingLabelText="Tual Sayısı"
                        id="tualAlbumNumber"
                        onChange={(e) => (e.target.value <= 127) ? this.setState({tualAlbumNumber: e.target.value}) : -1}
                        defaultValue={this.state.tualAlbumNumber}
                        value={this.state.tualAlbumNumber}
                    />
                </div>

                <div className="buttonDiv">
                    <RaisedButton
                        label="Ekle"
                        type="button"
                        onClick={this.tualSubmit.bind(this)}
                        disabled={(this.state.tualAlbumEbatValue === null) ? "disabled":""}
                        icon={<i className="material-icons">add</i>}
                        primary={true} />
                </div>

            </div>
        );
    }

}


export default Tual;


// WEBPACK FOOTER //
// ./src/components/small/tual.js